import { EXERCISE_TYPES } from "../../variables/exerciseVariables";

/**
 * Registro central dos módulos de exercício.
 *
 * Define comportamento, rotas e características de cada tipo.
 *
 * Estruturado para permitir expansão futura (ex: PDA, TM, Regex avançado).
 *
 * @author Willian
 */
export const EXERCISE_MODULES = {
  [EXERCISE_TYPES.GRAMMAR]: {
    key: EXERCISE_TYPES.GRAMMAR,
    route: "grammar",
    labelKey: "grammar",
    hasGrammar: true,
    hasAutomaton: false,
  },

  [EXERCISE_TYPES.MACHINE]: {
    key: EXERCISE_TYPES.MACHINE,
    route: "automaton",
    labelKey: "machine",
    hasGrammar: false,
    hasAutomaton: true,
  },

  [EXERCISE_TYPES.REGULAR_EXPRESSIONS]: {
    key: EXERCISE_TYPES.REGULAR_EXPRESSIONS,
    route: "automaton",
    labelKey: "regularExpressions",
    hasGrammar: false,
    hasAutomaton: false,
  },
};
